module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user) ? _c('b-card', {
    staticClass: "mb-3",
    class: {
      'user-revoked-card': _vm.userRevoked
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.userRevoked ? 'danger' : null,
      "header-border-variant": _vm.userRevoked ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('userAdministration.userDetails')) + "\r\n            ")])]), _vm._v(" "), (_vm.globalUser) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userOrganizationName')
    }
  }, [_c('b-link', {
    staticClass: "user-info-label",
    attrs: {
      "to": _vm.organizationLink
    }
  }, [_vm._v(_vm._s(_vm.user.organizationName))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.globalUser) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user.status) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userStatus')
    }
  }, [_c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "variant": _vm.priorityVariant[_vm.user.status - 1]
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('userAdministration.userStatuses.' + _vm.user.status)) + "\r\n                        ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.login))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.email))])])], 1)], 1), _vm._v(" "), (_vm.userRevoked) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userChangedId')
    }
  }, [_c('b-link', {
    staticClass: "user-info-label",
    attrs: {
      "to": _vm.userChangedLink
    }
  }, [_vm._v(_vm._s(_vm.user.changedId))])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLastChangeDate')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.user.lastChangeDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userChangedComments')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.changedComments))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateUserInformation($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.userDetailsChange')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.name.$error
    },
    attrs: {
      "name": "user.name"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.email.$error
    },
    attrs: {
      "type": "email",
      "name": "user.email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editUserInformationModal",
      modifiers: {
        "editUserInformationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                        " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-card', {
    staticClass: "mb-3",
    class: {
      'user-revoked-card': _vm.userRevoked
    },
    attrs: {
      "header": _vm.$t('userAdministration.userRolesClaims'),
      "header-text-variant": "dark",
      "border-variant": _vm.userRevoked ? 'danger' : null,
      "header-border-variant": _vm.userRevoked ? 'danger' : null
    }
  }, [(!_vm.editModeActive) ? _c('div', [(_vm.user.creationRoles) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationRoles), function(role) {
    return _c('b-list-group-item', {
      key: role,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + role)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user.creationClaims) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationClaims), function(claim) {
    return _c('b-list-group-item', {
      key: claim,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + claim)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e()], 1) : _c('div', [_c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "cover"
    }
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t('userAdministration.userPermissionsTableFilter')
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-btn', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.userPermissionsTableFilterClear')))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.roleItems) ? _c('b-table', {
    attrs: {
      "items": _vm.roleItems,
      "fields": _vm.roleFields,
      "id": "roles-table",
      "filter": _vm.filter
    },
    scopedSlots: _vm._u([{
      key: "cell(selected_role)",
      fn: function(row) {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "1"
          },
          on: {
            "click": row.toggleDetails
          }
        }, [(row.detailsShowing) ? _c('b-img', {
          attrs: {
            "src": require("@/assets/images/expand.svg"),
            "width": "15",
            "height": "15"
          }
        }) : _c('b-img', {
          attrs: {
            "src": require("@/assets/images/collapse.svg"),
            "width": "15",
            "height": "15"
          }
        })], 1), _vm._v(" "), _c('b-col', {
          attrs: {
            "cols": "1"
          }
        }, [(row.item.valid_role) ? _c('b-form-checkbox', {
          attrs: {
            "value": row.item.name,
            "indeterminate": _vm.indeterminate[row.item.name]
          },
          on: {
            "change": function($event) {
              return _vm.roleSelected(row.item)
            },
            "update:indeterminate": function($event) {
              return _vm.$set(_vm.indeterminate, row.item.name, $event)
            }
          },
          model: {
            value: (_vm.selectedRoles),
            callback: function($$v) {
              _vm.selectedRoles = $$v
            },
            expression: "selectedRoles"
          }
        }) : _vm._e()], 1)], 1)]
      }
    }, {
      key: "cell(localized_name)",
      fn: function(row) {
        return [_c('span', {
          staticClass: "contents-highlight",
          on: {
            "click": row.toggleDetails
          }
        }, [_vm._v("\r\n                            " + _vm._s(row.item.localized_name) + "\r\n                        ")])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('b-card', _vm._l((row.item.claims), function(claim, i) {
          return _c('b-row', {
            key: i
          }, [_c('b-col', {
            attrs: {
              "cols": "1"
            }
          }, [_c('b-form-checkbox', {
            staticClass: "mr-2",
            attrs: {
              "value": claim.value
            },
            on: {
              "change": function($event) {
                return _vm.claimSelected(claim)
              }
            },
            model: {
              value: (_vm.selectedClaims),
              callback: function($$v) {
                _vm.selectedClaims = $$v
              },
              expression: "selectedClaims"
            }
          })], 1), _vm._v(" "), _c('b-col', {
            attrs: {
              "cols": "5"
            }
          }, [_c('label', [_vm._v(_vm._s(claim.text))])])], 1)
        }), 1)]
      }
    }], null, false, 2011186232)
  }) : _vm._e()], 1), _vm._v(" "), (_vm.canChangeAuthority && !_vm.editModeActive) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.userRevoked || _vm.load
    },
    on: {
      "click": _vm.editRoles
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.edit')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : (_vm.editModeActive) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.userRevoked || _vm.load
    },
    on: {
      "click": _vm.updateChangedPermissions
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.save')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "info",
      "disabled": _vm.userRevoked || _vm.load
    },
    on: {
      "click": _vm.cancelEditRoles
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.cancel')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.hasUserResetPasswordClaim) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.resetUserPasswordConfirmationModal",
      modifiers: {
        "resetUserPasswordConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "disabled": _vm.userRevoked || _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.userResetPassword')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.revokeConfirmationModal",
      modifiers: {
        "revokeConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.userRevoked || _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.userRevoke')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.restoreConfirmationModal",
      modifiers: {
        "restoreConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "info",
      "disabled": !_vm.userRevoked || _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.userActivate')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "revokeConfirmationModal",
      "ok-title": _vm.$t('userAdministration.userRevoke'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.revokeUser
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.changedComments),
      expression: "user.changedComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": _vm.$t('userAdministration.userRevokeComments')
    },
    domProps: {
      "value": (_vm.user.changedComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "changedComments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "resetUserPasswordConfirmationModal",
      "ok-title": _vm.$t('userAdministration.userResetPassword'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.resetUserPassword
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userResetPasswordConfirmation')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "restoreConfirmationModal",
      "ok-title": _vm.$t('userAdministration.userActivate'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.restoreUser
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userActivateConfirmation')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    ref: "permissionUpdateConfirmationModal",
    attrs: {
      "header-bg-variant": "warning",
      "title": _vm.$t('forms.warning'),
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.saveEditRoles
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userPermissionUpdateConfirmation')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editUserInformationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateUserInformation
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.personalInformationChangeConfirmation')) + "\r\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3342773a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/misc/user-info/user-info.html
// module id = 759
// module chunks = 1